import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_ARRAY } from '../../../constants/productConfiguratorConstants';
import { addItemsToMapList, removeItemsFromMapList } from '../../../helpers/reduxHelper';

function defaultProducts(state, sceneId, loading = false, loaded = true) {
  if (state.data[sceneId]) return;
  state.data[sceneId] = {
    loading,
    loaded,
    products: [],
  };
}

const getInitialState = () => ({
  data: {},
});

const configuratorSceneProducts = createSlice({
  name: 'configuratorSceneProducts',
  initialState: getInitialState(),
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    fetchSceneProductsStart: (state, { payload }) => {
      const { sceneId } = payload;
      defaultProducts(state, sceneId, true, false);
      state.data[sceneId].loading = true;
      state.data[sceneId].loaded = false;
      state.data[sceneId].products = [];
    },
    fetchSceneProductsSuccess: (state, { payload }) => {
      const { sceneId, products } = payload;
      defaultProducts(state, sceneId);
      state.data[sceneId].loading = false;
      state.data[sceneId].loaded = true;
      state.data[sceneId].products = products;
    },
    addProductsToScene: (state, action) => {
      defaultProducts(state, action.payload.sceneId);
      addItemsToMapList('products', 'sceneId', 'products', 'data')(state, action);
    },
    removeProductsFromScene: removeItemsFromMapList('products', 'sceneId', 'data'),
  },
});

export const configuratorSceneProductsActions = configuratorSceneProducts.actions;
export const configuratorSceneProductsReducer = configuratorSceneProducts.reducer;

export const selectSceneProducts =
  (sceneId, { active } = {}) =>
  (state) => {
    const products = state.configuratorSceneProducts.data[sceneId]?.products || EMPTY_ARRAY;
    return products;
  };

export const selectSceneProductsLoaded = (sceneId) => (state) => {
  return state.configuratorSceneProducts.data[sceneId]?.loaded;
};

export const selectSceneProductsLoading = (sceneId) => (state) => {
  return state.configuratorSceneProducts.data[sceneId]?.loading;
};

export const selectSceneIsInData = (sceneId) => (state) => {
  const sceneData = state.configuratorSceneProducts.data[sceneId];
  return sceneData;
};

export const selectSceneHasProducts = (sceneId) => (state) => {
  return selectSceneProducts.length > 0;
};
